<template>
  <div
    class="flex flex-wrap px-4 xl:px-0 xl:-mx-8 bg-gray-300"
    :class="{ '!bg-blue-300': $isSol }"
  >
    <div
      v-if="SHOW_DEPARTURES_ON_TABS.includes(tripTab)"
      class="xl:w-10/12 w-12/12 mx-auto mb-12 pt-0 md:pt-8"
    >
      <HydrateWhenVisible>
        <LazyDeparturesTab
          :key="`tab-${trip?.id}`"
          :calendar="calendar"
          :flight-trip="!!trip.flight_trip"
          :main-tab="false"
          :loading="loading"
          :show-seats-left="!destinationPage"
        />
      </HydrateWhenVisible>
    </div>
  </div>

  <div class="flex flex-wrap px-4 xl:px-0 xl:-mx-8">
    <div class="xl:w-10/12 w-12/12 mx-auto mb-12">
      <HydrateWhenVisible>
        <LazySuggested
          v-if="suggested && suggested.length"
          :key="`suggested-${trip?.id}`"
          :suggested="suggested"
        />
      </HydrateWhenVisible>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

const SHOW_DEPARTURES_ON_TABS = ['details', 'info']

export default defineNuxtComponent({
  data () {
    return {
      loading: false,
      SHOW_DEPARTURES_ON_TABS,
    }
  },

  computed: {
    ...mapState(useTripStore, {
      suggested: 'suggestedTriptypes',
      trip: 'trip',
      tripTab: 'tripTab',
      calendar: 'calendar',
    }),

    destinationPage () {
      return /^\/destination/.test(this.$route.path)
    },
  },
})
</script>
